import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Bell, BellRing, Loader2 } from "lucide-react";

export default function ReleaseReminderButton({ filmId, user }) {
  const location = useLocation();
  const [subscribed, setSubscribed] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get(`/films/${filmId}/remind-me`).then(({ data }) => setSubscribed(data.subscribed)).catch(() => setSubscribed(false));
  }, [filmId, user]);

  if (!user) {
    return (
      <Link
        to="/login"
        state={{ from: location.pathname }}
        className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-sky-400/40 text-sky-200 hover:bg-sky-500/10 text-sm font-semibold transition-colors"
        data-testid="remind-me-login"
      >
        <Bell className="w-4 h-4" /> Log in to get notified on release
      </Link>
    );
  }

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = subscribed ? await api.delete(`/films/${filmId}/remind-me`) : await api.post(`/films/${filmId}/remind-me`);
      setSubscribed(data.subscribed);
      toast.success(data.subscribed ? "We'll email you the moment it's released" : "Reminder cancelled");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update your reminder");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy || subscribed === null}
      className={`mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${subscribed ? "bg-sky-500/15 text-sky-200 border border-sky-400/40 hover:bg-sky-500/25" : "bg-sky-500 text-white hover:bg-sky-400"}`}
      data-testid="remind-me-btn"
      data-subscribed={subscribed ? "true" : "false"}
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : subscribed ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {subscribed ? "You'll be notified · tap to cancel" : "Notify me on release"}
    </button>
  );
}
